export default "__VITE_ASSET__CN$tjtK3__"